import styled from 'styled-components';

import { Multiselect } from '@dreryk/react-components';

export const StyledHealthcareProviderLocationMultiselect = styled(Multiselect)`
   width: 300px;
` as typeof Multiselect;
